
import { isOnline } from "@/utils/connectionUtils";
import { toast } from "sonner";

export const handleNetworkError = (setNetworkError: (value: boolean) => void) => {
  setNetworkError(true);
  toast.error("You appear to be offline", {
    description: "Please check your connection and try again"
  });
};

export const showReconnectedToast = () => {
  toast.info("Connection restored. You can retry your last message now.");
};
